module.exports = __webpack_public_path__ + "static/media/thumbnail.f062a271.jpg";